import React from 'react'
import { graphql } from 'gatsby'

import Layout from '../components/layout'
import SEO from '../components/seo'
import Gallery from '../components/gallery'
import PostInfo from '../components/post-info'

const GalleryTemplate = ({ data }) => {
  const { gallery } = data

  return (
    <Layout>
      <SEO title={gallery.title} lang="en" description={gallery.description} />
      <section className="section section-feature gallery-heading">
        <div className="content">
          <h1>{gallery.title}</h1>
          <PostInfo
            author={gallery.author}
            category={gallery.category}
            publishAt={gallery.publishAt.local}
          />
        </div>
      </section>
      <section className="section gallery-wrapper">
        <Gallery items={gallery.images} />
      </section>
    </Layout>
  )
}

export const query = graphql`
  query GalleryTemplateQuery($id: String!) {
    gallery: sanityGallery(id: { eq: $id }) {
      _id
      title
      author {
        name
        slug {
          current
        }
      }
      category {
        name
        slug {
          current
        }
      }
      images {
        image {
          asset {
            _id
            fluid(maxWidth: 1024) {
              ...GatsbySanityImageFluid
            }
          }
        }
        _rawCaption
      }
      publishAt {
        local
      }
    }
  }
`

export default GalleryTemplate
